import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  Input,
  ChangeDetectorRef,
  OnDestroy,
  ViewChild,
  QueryList,
  ElementRef,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest, Observable, Subscription } from 'rxjs';
import { takeUntil, map, skip } from 'rxjs/operators';
import { SetLocationActionTrns } from 'src/app/store/transaction';
import { isSdfCardFlow } from '../../../config/app-config';
import { LocationDetail, MgLocation } from '../../../models/location.model';
import { GeolocationService } from '../../../services/geolocation.service';
import { LocationFinderService } from '../../../services/location-finder.service';
import { BaseComponent } from '../../../shared/base.component';
import { SetLocationAction } from '../../../store/locations/location.actions';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { Labels, SdfCardLabels } from 'src/app/app.models';
import { Who } from '../../../models/location.model';
import { getFilteredSearchResults } from '../../../store/locations/location.selectors';
import { MobileBreakPointsService } from 'src/app/services/mobileBreakPoints.service';
import {
  animate,
  AnimationEvent,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
// import { slideInOutAnimation, overlayFadeInOutAnimation } from 'src/app/shared/reusable-animations/card-estimate-drawer-animations'; // #MAWX3276: commenting out directions feature
import { slideInOutAnimation } from 'src/app/shared/reusable-animations/card-estimate-drawer-animations';
import { EnvService } from 'src/app/services/env.service';
// import { WindowService } from 'src/app/services/window.service'; // #MAWX3276: commenting out directions feature
export interface LocationOperatingHours {
  [key: string]: string; // Allowing string indexes
  monHours: string;
  tueHours: string;
  wedHours: string;
  thuHours: string;
  friHours: string;
  satHours: string;
  sunHours: string;
}
@Component({
    selector: 'app-location-search-result',
    templateUrl: './location-search-result.component.html',
    styleUrls: ['./location-search-result.component.scss'],
    animations: [
        trigger('slideStore', [
            state('active', style({ transform: 'translateX(0)', display: 'flex', opacity: 1 })),
            state('inactive', style({ transform: 'translateX(-100%)', display: 'none', opacity: 0 })),
            transition('active <=> inactive', animate('500ms ease-in-out')),
        ]),
        trigger('slideService', [
            state('active', style({ transform: 'translateX(0)', display: 'flex', opacity: 1 })),
            state('inactive', style({ transform: 'translateX(100%)', display: 'none', opacity: 0 })),
            transition('active <=> inactive', animate('800ms ease-in-out')),
        ]),
        trigger('expandCollapse', [
            state('expanded', style({ height: '*', overflow: 'hidden' })),
            state('collapsed', style({ height: '0px', overflow: 'hidden' })),
            transition('expanded <=> collapsed', [animate('300ms ease-in-out')]),
        ]),
        slideInOutAnimation,
        // overlayFadeInOutAnimation, // #MAWX3276: commenting out directions feature
    ],
    standalone: false
})
export class LocationSearchResultComponent
  extends BaseComponent
  implements OnInit, OnDestroy
{
  @Output() sendLocation: EventEmitter<MgLocation> =
    new EventEmitter<MgLocation>();
  @Output() closeDailogOnSelLoc: EventEmitter<void> = new EventEmitter<void>();
  @Output() viewMoreEvent: EventEmitter<void> = new EventEmitter<void>();
  isSdfCardFlow = false;
  selectedLocationIndex: number | null = null;
  isStoreActive: boolean = true;
  isMobileCardExpanded: boolean = false;
  isServiceActive: boolean = false;
  locationStoreHours: any[] = [];
  isStoreAnimationDone: boolean = true;
  doLocationNamesMatch: boolean | undefined;
  sdfCardLabels: SdfCardLabels;
  locationLabels: any;
  resultSelected: { visible: boolean; locDetails?: MgLocation } = {
    visible: false,
    locDetails: undefined,
  };
  todayDay: number = 0;
  public hideResult: boolean;
  public expandLocationCard: boolean = false;
  showStoreHours: boolean = true;
  isLocationMarkerSelected: boolean = true
  private hideResultSubscritor: Subscription;
  selectedIndex: number | null = null;
  singleLocationToview: any
  public _labels: any;
  @Input() flow: string;
  @Input() public set labels(labels: Labels) {
    this._labels = labels;
    this.locationLabels = labels.stellar.location;
    this.sdfCardLabels = labels.stellar.sdfcard;
  }
  public get labels() {
    return this._labels;
  }
  @Input() isViewMoreBtnHidden: boolean;
  @Input() isTierFilteringEnabled: boolean; // #featureFlag

  searchResults: MgLocation[];
  searchError: boolean = false;
  isBankAccountRequired: boolean = true;
  isMobile$: Observable<boolean>;
  isTabletOrMobile$: Observable<boolean>;
  daysOfWeek: string[] = [
    'monHours',
    'tueHours',
    'wedHours',
    'thuHours',
    'friHours',
    'satHours',
    'sunHours',
  ];
  mapSnapshotUrl$:Observable<string | HTMLImageElement>
  // isBottomSheetOpen: boolean = false; // #MAWX3276: commenting out directions feature
  // directionsLocation: MgLocation;

  constructor(
    public locationFinderService: LocationFinderService,
    public geolocationService: GeolocationService,
    private store: Store<any>,
    public ref: ChangeDetectorRef,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private mobileBreakPointsService: MobileBreakPointsService,
    // private windowService: WindowService,
    private env: EnvService
  ) {
    super();
    this.isSdfCardFlow = isSdfCardFlow;
    this.matIconRegistry.addSvgIcon(
      'ico-tag-loc',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../../../assets/images/map-location/icon-tag.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'ico-clock',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../../../assets/images/map-location/icon-clock.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'ico-arrow-up',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../../../assets/images/map-location/icon-arrow-up.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'ico-phone',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../../../assets/images/map-location/icon-phone.svg'
      )
    );
    this.hideResultSubscritor = this.locationFinderService.hide$.subscribe(
      ({ who, value }: any) => { // Todo: Tim: Fix types
        if (who === Who.listResult) {
          this.hideResult = value;
        }
      }
    );
    const date = new Date();
    this.todayDay = Number(date.getDay());
  }

  ngOnInit() {
    this.isMobile$ = this.mobileBreakPointsService
      .mobileBreakPoints$ as Observable<boolean>;
    this.isTabletOrMobile$ = this.mobileBreakPointsService
      .tabletOrMobileBreakPoints$ as Observable<boolean>;
    this.store.select(getFilteredSearchResults(this.flow)).subscribe((results: any) => { // Todo: Tim: Fix types
      if (results?.length > 0) this.searchError = false;
      this.searchResults = results?.locations
    });
    this.locationFinderService.searchCompleted
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        const searchResults = this.locationFinderService.searchResults;
        if (searchResults && searchResults.locations && !searchResults.error) {
          this.searchError = false;
          this.searchResults = searchResults.locations;
        }
        if (
          searchResults &&
          (!searchResults?.locations || searchResults?.locations?.length === 0)
        ) {
          this.searchResults = <MgLocation[]>[];
          this.searchError = true;
        }
        if (typeof searchResults !== 'undefined') {
          this.searchResults.map((sR: MgLocation) => {
            sR = { ...sR, expandLocationCard: false };
            return sR;
          });
        } else {
          this.searchResults = <MgLocation[]>[];
        }

        this.ref.detectChanges();
      });

    if (
      !!this.locationFinderService.searchResults &&
      this.locationFinderService.searchResults.locations
    ) {
      this.searchResults = this.locationFinderService.searchResults.locations;
    }
    this.locationFinderService.selectedLocation$.subscribe(
      (selectedLocation: any) => { // Todo: Tim: Fix types
        this.selectedLocationIndex = this.searchResults?.indexOf(
          selectedLocation!
        );
      }
    );
    combineLatest([
      this.locationFinderService.selectedLocation$,
      this.isTabletOrMobile$
    ]).pipe(skip(2)).subscribe(([selLoc, isTabletOrMobile]: any[]) => { // Todo: Tim: Fix types
      if(isTabletOrMobile && selLoc) {
        this.expandMobileCard(true, selLoc!)
      } else {
        const findLocationIndex = this.searchResults.indexOf(selLoc!)
        this.toggleStoreHours(findLocationIndex!)
        this.showStoreHours = !this.showStoreHours
        this.isLocationMarkerSelected = !this.isLocationMarkerSelected
        this.selectedLocationIndex = findLocationIndex
      }
    })
  }

  public selectLocator(selLoc: MgLocation, index: number) {
    this.selectedLocationIndex = index
    this.isLocationMarkerSelected = !this.isLocationMarkerSelected
    this.locationFinderService.updateSelectedBranch(selLoc);
    this.locationFinderService.branchSelected.next(true);
    const address = this.locationFinderService.getFormattedAddress({
      addressLine1: selLoc?.locationDetails?.addressLine1,
      addressLine2: selLoc?.locationDetails?.addressLine2,
      addressLine3: selLoc?.locationDetails?.addressLine3,
      city: selLoc?.locationDetails?.city,
      state: selLoc?.locationDetails?.state,
      zipCode: selLoc?.locationDetails?.zipCode,
      postalCode: selLoc?.locationDetails?.postalCode,
    });
    
    this.locationFinderService.setDefaultAddress(address);

    if (this.isSdfCardFlow) {
      this.store.dispatch(SetLocationActionTrns({ selectedLocation: selLoc }));
      this.store.dispatch(SetLocationAction({ selectedLocation: selLoc }));
      // console.log(`%c EMIT selLoc: isSdfCardFlow:${this.isSdfCardFlow}`, "background:orange", selLoc);
      this.closeDailogOnSelLoc.emit();
    } else {
      this.sendLocation.emit(selLoc);
    }
  }

  // public openBottomSheet(location: any) { // #MAWX3276: commenting out directions feature
  //   this.directionsLocation = location;
  //   this.isBottomSheetOpen = true;
  // }

  // public closeBottomSheet() {
  //   this.isBottomSheetOpen = false;
  // }

  // public launchDirections(result: any, mapProvider: 'apple' | 'google' | 'waze') {
  //   if (!result) return;
    
  //   const latitude = result.locationDetails.latitude;
  //   const longitude = result.locationDetails.longitude;
  //   const locationName = encodeURIComponent(result.locationDetails.name || '');
  //   const address = encodeURIComponent(
  //     `${result.locationDetails.addressLine1}, ${result.locationDetails.city}, ${result.locationDetails.state || ''} ${result.locationDetails.zipCode || result.locationDetails.postalCode || ''}`
  //   );

  //   const userAgent = this.windowService.windowRef.navigator.userAgent;
  //   const isIOS = /iPhone|iPad|iPod/i.test(userAgent);
  //   const isAndroid = /Android/i.test(userAgent);

  //   let mapsUrl = '';
  //   if (mapProvider === 'waze') {
  //     mapsUrl = `https://waze.com/ul?ll=${latitude},${longitude}&navigate=yes`;
  //   }
  //   else if (mapProvider === 'apple') {
  //     mapsUrl = isIOS ?
  //     `maps://?q=${locationName}&ll=${latitude},${longitude}` :
  //     `https://maps.apple.com/?ll=${latitude},${longitude}&q=${locationName}`;
  //   }
  //   else if (mapProvider === 'google') {
  //     mapsUrl = isAndroid ?
  //       `geo:${latitude},${longitude}?q=${address}` :
  //       `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;
  //   }
    
  //   if (mapsUrl) {
  //     this.windowService.windowRef.open(mapsUrl, '_blank')
  //   }
  // }

  public getDistance(locDetail: LocationDetail) {
    const distNum = Number(locDetail.distance);
    const retDistance =
      parseFloat(distNum.toFixed(2)).toString() +
      ' ' +
      this.labels.stellar.location.miles.slice(0, 2);
    return retDistance;
  }

  public toggleStoreHours(i: number) {
    // this.selectedLocationIndex = i
    if (this.selectedIndex === i) {
      this.selectedIndex = null;
      this.expandLocationCard = false;
    } else {
      this.selectedIndex = i;
      this.expandLocationCard = true;
    }
    // const iActive = this.searchResults.findIndex(
    //   (item: MgLocation) => item.expandLocationCard === true
    // );
    // this.expandLocationCard = !this.expandLocationCard;

    this.searchResults = this.searchResults.map((result, i) => ({
      ...result,
      expandLocationCard: i === this.selectedIndex,
    }));
    this.showStoreHours = true;
  }

  isSelectedIndex(index: number): boolean {
    return this.selectedIndex === index;
  }
  public go2CardDetailsFloating(result: MgLocation | undefined = undefined) {
    if (result === undefined) {
      this.resultSelected.visible = false;
      return;
    }
    this.resultSelected.locDetails = result;
    this.resultSelected.visible = !this.resultSelected.visible;
  }

  public toggleIsBankAccountRequired() {
    this.isBankAccountRequired = !this.isBankAccountRequired;
  }

  onStoreAnimationDone(event: AnimationEvent) {
    if (event.toState === 'inactive') {
      setTimeout(() => {
        this.isStoreAnimationDone = true;
      }, 200);
    }
  }

  public switchStoreServiceViw(view: 'store' | 'services') {
    if (view === 'store' || this.isStoreAnimationDone) {
      this.isStoreActive = view === 'store';
      this.isServiceActive = view === 'services';
    }
  }

  toggleHideStoreHours() {
    this.showStoreHours = !this.showStoreHours;
  }

  expandMobileCard(isExpanded: boolean, selloc: MgLocation) {
    this.isMobileCardExpanded = isExpanded;
    this.updateColor()
    this.singleLocationToview = selloc
    this.mapSnapshotUrl$ = this.locationFinderService.getMapSnapshotUrl(selloc.locationDetails.latitude!, selloc.locationDetails.longitude!).pipe(
      map((url: any)=> {
        return url
      })
    )
  }

  collapseMobileCard() {
    this.isMobileCardExpanded = false;
    this.updateColor()
  }

  updateColor() {
    const mapElement = document.querySelector(
      '.outer-container'
    ) as HTMLElement;
    if (mapElement) {
      mapElement.style.backgroundColor = this.isMobileCardExpanded
        ? '#1A1A1A'
        : '';
    }

    this.ref.detectChanges();
  }

  isLocationClosedAllDay(hours: string): boolean {
    const hoursLowerCase = hours.toLowerCase().trim();
    if (hoursLowerCase.includes('closed') || hoursLowerCase.includes('12:00 am - 12:00 am')) {
      return true;
    }
    else {
      return false;
    }
  }

  public ngOnDestroy(): void {
    this.hideResultSubscritor.unsubscribe();
  }

  handleViewMore() {
    this.viewMoreEvent.emit();
  }
}
